<template>
    <div class="video-modal">

        <div :id="modalId" class="uk-flex-top" uk-modal>
            <div class="uk-modal-dialog uk-width-auto uk-margin-auto-vertical">
                <button class="uk-modal-close-outside" type="button" uk-close/>
                <iframe v-if="isYoutube()"
                        :src="frameSrc"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        height="720"
                        uk-responsive
                        uk-video width="1280"/>

                <iframe v-else-if="!isVimeoDirect()"
                        :src="frameSrc"
                        allow="autoplay; fullscreen; picture-in-picture" height="720"
                        uk-responsive
                        uk-video width="1280"/>

                <video v-else
                       :src="videoSrc" class="modal-video"
                       controls
                       controlsList="nodownload noremoteplayback" oncontextmenu="return false;" playsinline
                       uk-video="autoplay: inview"/>
            </div>
        </div>

    </div>
</template>


<script>

import UIkit from "uikit";

export default {
    name: 'VideoModal',
    props: {
        modalId: String,
        videoSrc: String,
        anchor: String,
    },
    data() {
        return {
            // The embed URL is only set while the modal is open: an iframe
            // carrying autoplay=1 must not exist before the user asked for the
            // video, and dropping the src on close stops Vimeo/YouTube from
            // playing on behind the closed modal.
            frameSrc: null,
        };
    },
    mounted() {
        const modalElement = document.getElementById(this.modalId);
        let self = this;

        modalElement.addEventListener("beforeshow", function () {
            self.frameSrc = self.getEmbedUrl();

            let videoList = document.getElementsByTagName("video");
            for (let i = 0, j = videoList.length; i < j; i++) {
                let video = videoList[i];
                if (video && !video.paused) {
                    video.pause();
                }
            }
        });

        modalElement.addEventListener("shown", function () {
            let video = self.$el.querySelector("video");

            if (video && video.paused) {
                let started = video.play();
                if (started) {
                    started.catch(function () {
                    });
                }
            }
        });

        modalElement.addEventListener("hidden", function () {
            self.frameSrc = null;
        });

        modalElement.addEventListener("beforehide", function () {
            let videoList = document.getElementsByTagName("video");
            for (let i = 0, j = videoList.length; i < j; i++) {
                let video = videoList[i];

                if (!video.muted) {
                    continue;
                }

                if (video && video.paused) {
                    video.play();
                }
            }
        });

        this.openFromHash();
    },
    methods: {
        // Shared links carry "#<anchor>"; land on the video, then open it.
        openFromHash() {
            if (!this.anchor) {
                return;
            }

            let hash = decodeURIComponent(window.location.hash).substring(1);
            if (!hash || !this.anchor.split(',').includes(hash)) {
                return;
            }

            let target = document.getElementById(this.anchor.split(',')[0]);
            if (target) {
                setTimeout(function () {
                    target.scrollIntoView({behavior: "smooth", block: "center"});
                }, 50);
            }

            this.showWhenReady(0);
        },
        // UIkit attaches the modal component a few frames after Vue renders it,
        // and showing it before that leaves the modal closed for good.
        showWhenReady(attempt) {
            const modalElement = document.getElementById(this.modalId);
            const component = modalElement ? UIkit.getComponent(modalElement, "modal") : null;

            if (component) {
                component.show();
                return;
            }

            if (attempt >= 40) {
                return;
            }

            let self = this;
            setTimeout(function () {
                self.showWhenReady(attempt + 1);
            }, 100);
        },
        getEmbedUrl() {
            if (this.isYoutube()) {
                return 'https://www.youtube-nocookie.com/embed/' + this.getYoutubeId() + '?autoplay=1&rel=0';
            }

            let url = 'https://player.vimeo.com/video/' + this.getVimeoId();

            return url + (url.includes('?') ? '&' : '?') + 'autoplay=1';
        },
        getYoutubeId() {
            let parts = this.videoSrc.split("v=");

            return parts[parts.length - 1];
        },
        getVimeoId() {
            let parts = this.videoSrc.split("vimeo.com/");

            let subParts = parts[parts.length - 1].split("/");

            let merged = subParts[0];
            if (subParts[1]) {
                merged += "?h=" + subParts[1];
            }

            return merged;
        },
        isYoutube() {
            if (this.videoSrc.includes('youtube')) {
                return true;
            }

            return false;
        },
        isVimeoDirect() {
            if (this.videoSrc.includes('player.vimeo')) {
                return true;
            }

            return false;
        },
    }
}

</script>


<style lang="scss" scoped>

.uk-modal-dialog {
    background: #000 !important;
}

.modal-video {
    max-height: 90vh;
    min-height: 50vh;
}

</style>
